<template>
  <div class="flex-1 h-0 flex flex-col">
    <div class="flex-1 h-0 flex gap-4">
      <div class="w-3/5 p-4 sm:p-6 overflow-auto">
        <fieldset>
          <legend class="text-base font-medium text-gray-900">Select a base template</legend>

          <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4">
            <label
              class="relative bg-white border rounded-lg shadow-sm flex flex-col cursor-pointer focus:outline-none"
              :class="[baseEmailTemplateInput === null ? 'border-transparent' : 'border-gray-300']"
            >
              <input
                type="radio"
                name="email-template"
                :value="null"
                class="sr-only"
                @input="baseEmailTemplateInput = null"
              />
              <div class="relative aspect-w-16 aspect-h-9 bg-gray-100 rounded-t-lg overflow-hidden">
                <div>
                  <div
                    class="w-2/3 h-full mx-auto mt-4 rounded-t shadow ring-1 bg-white ring-black ring-opacity-5"
                  />
                </div>
              </div>
              <div class="border-t p-4 truncate text-sm">Emtpy</div>
              <svg
                class="absolute top-4 right-4 h-5 w-5 text-indigo-600"
                :class="[baseEmailTemplateInput === null ? '' : 'hidden']"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <div
                class="absolute rounded-lg -inset-px border-2"
                :class="[
                  baseEmailTemplateInput === null ? 'border-blue-600' : 'border-transparent',
                ]"
              />
            </label>

            <label
              v-for="emailTemplate in emailTemplates"
              :key="emailTemplate.id"
              class="relative bg-white border rounded-lg shadow-sm flex flex-col cursor-pointer focus:outline-none"
              :class="[
                isCurrentEmailTemplate(emailTemplate) ? 'border-transparent' : 'border-gray-300',
              ]"
            >
              <input
                type="radio"
                name="email-template"
                :value="emailTemplate"
                class="sr-only"
                @input="baseEmailTemplateInput = emailTemplate"
              />
              <div class="relative aspect-w-16 aspect-h-9 bg-gray-100 rounded-t-lg overflow-hidden">
                <div>
                  <img
                    :src="emailTemplate.preview_url"
                    class="w-2/3 mx-auto mt-4 rounded-t shadow ring-1 ring-black ring-opacity-5"
                  />
                </div>
              </div>
              <div class="border-t p-4 truncate text-sm">
                {{ emailTemplate.name }}
              </div>
              <svg
                class="absolute top-4 right-4 h-5 w-5 text-indigo-600"
                :class="[isCurrentEmailTemplate(emailTemplate) ? '' : 'hidden']"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <div
                class="absolute rounded-lg -inset-px border-2"
                :class="[
                  isCurrentEmailTemplate(emailTemplate) ? 'border-blue-600' : 'border-transparent',
                ]"
              />
            </label>
          </div>
        </fieldset>
      </div>
      <div class="w-2/5 p-4 sm:p-6">
        <h5 class="text-base font-medium text-gray-900">Details</h5>
        <div
          class="mt-4 relative aspect-w-1 aspect-h-1 bg-gray-100 border rounded-lg overflow-hidden"
        >
          <div class="w-full px-4 pt-4">
            <img
              v-if="baseEmailTemplateInput"
              :src="baseEmailTemplateInput.preview_url"
              class="w-full rounded-t shadow ring-1 ring-black ring-opacity-5"
            />
            <div
              v-else
              class="h-full mx-auto rounded-t shadow ring-1 bg-white ring-black ring-opacity-5"
            />
          </div>
        </div>
        <div class="mt-4">
          <dl class="grid grid-cols-1">
            <div>
              <dt class="text-sm font-medium text-gray-500">Name</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ baseEmailTemplateInput ? baseEmailTemplateInput.name : 'Empty' }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <div class="flex-none p-4 sm:p-6 border-t text-right">
      <BaseButton primary @click="$emit('next-step')"> Next </BaseButton>
    </div>
  </div>
</template>

<script>
import { emailTemplatesClient } from '@/api/clients';

export default {
  props: {
    emailTemplateData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emailTemplates: [],
    };
  },
  computed: {
    baseEmailTemplateInput: {
      get() {
        return this.emailTemplateData.baseEmailTemplate || null;
      },
      set(value) {
        this.$emit('base-email-template:update', value);
      },
    },
  },
  created() {
    this.fetchEmailTemplates();
  },
  methods: {
    isCurrentEmailTemplate(emailTemplate) {
      return emailTemplate.id === this.baseEmailTemplateInput?.id;
    },
    async fetchEmailTemplates() {
      const response = await emailTemplatesClient.list({ include: 'preview' });

      this.emailTemplates = response.data;
    },
  },
};
</script>
